var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30025e-09 6.832L14.2053 14.22C14.3478 14.2941 14.5061 14.3328 14.6667 14.3328C14.8273 14.3328 14.9855 14.2941 15.128 14.22L29.3333 6.83333V19.6667C29.3334 20.7735 28.9099 21.8384 28.1498 22.643C27.3896 23.4475 26.3504 23.9307 25.2453 23.9933L25 24H4.33333C3.22648 24.0001 2.16156 23.5766 1.35703 22.8164C0.552489 22.0563 0.0693316 21.0171 0.00666683 19.912L9.30025e-09 19.6667V6.832ZM4.33333 9.30025e-09H25C26.1069 -7.24623e-05 27.1718 0.423405 27.9763 1.18356C28.7808 1.94372 29.264 2.98293 29.3267 4.088L29.3333 4.33333V4.57867L14.6667 12.2053L9.30025e-09 4.57867V4.33333C-7.24623e-05 3.22648 0.423406 2.16156 1.18356 1.35703C1.94372 0.552489 2.98293 0.0693316 4.088 0.00666683L4.33333 9.30025e-09Z",
    fill: "#57769C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEmail);
export default __webpack_public_path__ + "static/media/logo-email.bf66c2288eb9edec4abdf9aab3805adf.svg";
export { ForwardRef as ReactComponent };